import React, { useEffect, useState, useContext } from "react";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Addimprovementsecond12() {
  const {
    setCandidateid12,
    setCastecode12,
    setDivyangcode12,
    candidateid12,
    mode12,
    setMode12,
    setDocverify12,
    class12regulardata,
  } = useContext(ContextBoard);

  const Navigate = useNavigate();
  const location = useLocation();
  const { studentData } = location.state || {};
  // console.log("Received studentData:", studentData);

  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteListnew, setCasteListnew] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [language1_2new, setLanguage1_2new] = useState([]);

  const [additional, setAdditional] = useState([]);
  const [compulsary, setCompulsary] = useState([]);
  const [compulsory_one, setCompulsoryOne] = useState("");
  const [compulsory_two, setCompulsoryTwo] = useState("");
  const [compulsory_three, setCompulsoryThree] = useState("");

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [formData, setFormData] = useState({
    passingyear: "",
    roll_code: "",
    roll_number: "",
    registration_number: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    faculty: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    examination_medium: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    elective_subject: "",
    language_one_code: "",
    language_two_code: "",
    compulsory_one_code: "",
    compulsory_two_code: "",
    compulsory_three_code: "",
    additional_subject_code: "",
    elective_subject_code: "",
    selected_language_one: "",
    selected_language_two: "",
    selected_compulsory_one: "",
    selected_compulsory_two: "",
    selected_compulsory_three: "",
    selected_additional: "",
    selected_elective: "",
    apaar_id: "",
    pen_no: "",
  });
  const [fieldsMissing, setFieldsMissing] = useState({
    religion: false,
    caste: false,
  });
  const casteValue = studentData?.caste
    ? studentData.caste
    : studentData?.editStudent_data?.caste
    ? studentData?.editStudent_data?.caste
    : "";
  const name =
    studentData?.candidatE_NAME ??
    studentData?.editStudent_data?.candidatE_NAME ??
    "";
  const religionvalue =
    studentData?.religion ?? studentData?.editStudent_data?.religion ?? "";

  useEffect(() => {
    if (!loading) {
      if (!formData?.candidate_name) {
        Navigate("/class-xii-dashboard");
        return;
      }

      setFieldsMissing({
        caste: !casteValue,
        religion: !religionvalue,
      });
    }
  }, [loading, formData?.candidate_name, casteValue, religionvalue, Navigate]);

  useEffect(() => {
    // if (!studentData || (!studentData.data && !studentData.candidatE_ID)) {
    //   Navigate("/class-x-dashboard");
    //   return;
    // }
    if (mode12 === "edit") {
      setFinaledit(true);
      setIsEditMode(true);
      setIsPreviewed(true);
    }
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const language1_2 = getSessionData("language1_2") || [];
    const additional = getSessionData("additional") || [];
    const compulsary = getSessionData("compulsary") || [];
    const compulsory_one = getSessionData("compulsory_one") || [];
    const compulsory_two = getSessionData("compulsory_two") || [];
    const compulsory_three = getSessionData("compulsory_three") || [];
    setBlockList(Array.isArray(blockList) ? blockList : []);
    setCasteListnew(Array.isArray(casteList) ? casteList : []);
    setDistrictList(Array.isArray(districtList) ? districtList : []);
    setDivyangList(Array.isArray(divyangList) ? divyangList : []);
    setMediumList(Array.isArray(mediumList) ? mediumList : []);
    setReligionList(Array.isArray(religionList) ? religionList : []);
    setStateList(Array.isArray(stateList) ? stateList : []);
    setLanguage1_2new(Array.isArray(language1_2) ? language1_2 : []);
    setAdditional(Array.isArray(additional) ? additional : []);
    setCompulsary(Array.isArray(compulsary) ? compulsary : []);
    setCompulsoryOne(compulsory_one ? compulsory_one : []);
    setCompulsoryTwo(compulsory_two ? compulsory_two : []);
    setCompulsoryThree(compulsory_three ? compulsory_three : []);
    // debugger;
    // 🔹 Set common student details
    setFormData((prev) => ({
      ...prev,
      passingyear:
        studentData?.cL_12_EXAM_YEAR ??
        studentData?.editStudent_data?.cL_12_EXAM_YEAR ??
        "",
      roll_code: sessionStorage.getItem("schoolCode") ?? "",
      roll_number:
        studentData?.rolL_NO ?? studentData?.editStudent_data?.rolL_NO ?? "",
      registration_number:
        studentData?.registratioN_ID_CL_12 ??
        studentData?.editStudent_data?.registratioN_ID_CL_12 ??
        "",
      faculty:
        studentData?.faculty ?? studentData?.editStudent_data?.stream ?? "",
      religion:
        studentData?.religion ?? studentData?.editStudent_data?.religion ?? "",
      candidate_name:
        studentData?.candidatE_NAME ??
        studentData?.editStudent_data?.candidatE_NAME ??
        "",
      gender:
        studentData?.gender ?? studentData?.editStudent_data?.gender ?? "",
      date_of_birth:
        studentData?.dob ?? studentData?.editStudent_data?.dob ?? "",
      fathers_name:
        studentData?.fatheR_NAME ??
        studentData?.editStudent_data?.fatheR_NAME ??
        "",
      mothers_name:
        studentData?.motheR_NAME ??
        studentData?.editStudent_data?.motheR_NAME ??
        "",
      divyang_val:
        studentData?.divyang ?? studentData?.editStudent_data?.divyang ?? "",
      caste_val:
        studentData?.caste ?? studentData?.editStudent_data?.caste ?? "",
      category_choice:
        studentData?.studenT_EXAM_SUB_CATEGORY ??
        studentData?.editStudent_data?.studenT_EXAM_SUB_CATEGORY ??
        "",
      board_name:
        studentData?.board ?? studentData?.editStudent_data?.board ?? "",
      examination_medium:
        studentData?.mediuM_OF_EXAM ??
        studentData?.editStudent_data?.mediuM_OF_EXAM ??
        "",
      language_one:
        studentData?.subjecT_NAME1 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME1 ??
        "",
      language_two:
        studentData?.subjecT_NAME2 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME2 ??
        "",
      compulsory_one:
        studentData?.subjecT_NAME3 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME3 ??
        "",
      compulsory_two:
        studentData?.subjecT_NAME4 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME4 ??
        "",
      compulsory_three:
        studentData?.subjecT_NAME5 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME5 ??
        "",
      additional_subject:
        studentData?.subjecT_NAME6 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME6 ??
        "",
      elective_subject:
        studentData?.subjecT_NAME7 ??
        studentData?.editStudent_data?.b_SUBJECT_NAME7 ??
        "",
      language_one_code:
        studentData?.suB_1 ??
        studentData?.editStudent_data?.b_SUBJECT_1_CODE ??
        "",
      language_two_code:
        studentData?.suB_2 ??
        studentData?.editStudent_data?.b_SUBJECT_2_CODE ??
        "",
      compulsory_one_code:
        studentData?.suB_3 ??
        studentData?.editStudent_data?.b_SUBJECT_3_CODE ??
        "",
      compulsory_two_code:
        studentData?.suB_4 ??
        studentData?.editStudent_data?.b_SUBJECT_4_CODE ??
        "",
      compulsory_three_code:
        studentData?.suB_5 ??
        studentData?.editStudent_data?.b_SUBJECT_5_CODE ??
        "",
      additional_subject_code:
        studentData?.suB_6 ??
        studentData?.editStudent_data?.b_SUBJECT_6_CODE ??
        "",
      elective_subject_code:
        studentData?.suB_7 ??
        studentData?.editStudent_data?.b_SUBJECT_7_CODE ??
        "",
      apaar_id:
        studentData?.apaaR_ID ?? studentData?.editStudent_data?.apaaR_ID ?? "",
      pen_no:
        studentData?.peN_NO ?? studentData?.editStudent_data?.peN_NO ?? "",
      selected_language_one: studentData?.editStudent_data?.suB_1 ?? "",
      selected_language_two: studentData?.editStudent_data?.suB_2 ?? "",
      selected_compulsory_one: studentData?.editStudent_data?.suB_3 ?? "",
      selected_compulsory_two: studentData?.editStudent_data?.suB_4 ?? "",
      selected_compulsory_three: studentData?.editStudent_data?.suB_5 ?? "",
      selected_additional: studentData?.editStudent_data?.suB_6 ?? "",
      selected_elective: studentData?.editStudent_data?.suB_7 ?? "",
    }));

    setLoading(false);
  }, []);
  const handleChange = (e) => {
    // debugger;
    const { name, value } = e.target;
    // const numericValue = value.replace(/\D/g, "");

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePenBlur = async () => {
    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");

      if (!penno || penno.length < 11 || penno.length > 14) return;

      const token = sessionStorage.getItem("tokenclassxii");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/PENNoCheckingStudentData_CL12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateid12 || "",
              peN_NO: penno,
            }),
          }
        );

        const result = await response.json();

        if (result.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "PEN(Permanent Education Number) No. Already Exists.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            pen_no: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying PEN No.", error);
      }
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleButtonClick = () => {
    const isEditMode = mode12;
    if (isEditMode === "edit") {
      handleEditSubmit();
    } else {
      handleSubmit();
    }
  };
  const updatedLateralstatus = sessionStorage.getItem("Class12LateralStatus");
  const handleSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassxii");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    const insertPayload = {
      GENDER: formData.gender || "",
      CANDIDATE_NAME: formData.candidate_name || "",
      DOB: formData.date_of_birth || "",
      FATHER_NAME: formData.fathers_name || "",
      MOTHER_NAME: formData.mothers_name || "",
      NATIONALITY: studentData.nationality || "",
      RELIGION: formData.religion || "",
      AADHAR_CARD: formData.aadhaR_CARD || "",
      APAAR_ID: formData.apaar_id || "",
      DIVYANG: formData.divyang_val || "",
      CASTE: formData.caste_val || "",
      CONTACT_NO: studentData.contacT_NO || "",
      EMAIL_ID: studentData.emaiL_ID || "",
      AREA: studentData.area || "",
      STATE: studentData.state || "",
      DISTRICT_ID: studentData.districT_ID || "",
      BLOCK: studentData.block || "",
      ADDRESS: studentData.address || "",
      PINCODE: studentData.pincode || "",
      CLASS_ROLL_NO: studentData.rolL_NO || "",
      STUDENT_EXAM_SUB_CATEGORY: formData.category_choice || "",
      MEDIUM_OF_EXAM: studentData.mediuM_OF_EXAM || "",
      SECTION: studentData.section || "",
      STREAM: studentData.faculty || "",
      PEN_NO: formData.pen_no || "",
      REGISTRATION_SESSION: studentData.sessioN_CODE || "",
      STUDENT_EXAM_CATEGORY: studentData.studenT_EXAM_CATEGORY || "",
      CANDIDATE_CODE: studentData.candidatE_ID || "",
      BOARD_NAME: studentData.board || "",
      registratioN_NO: formData.registration_number || "",
      sessioN_FULL_NAME: studentData.sessioN_FULL_NAME || "",
      PASSING_YEAR: formData.passingyear || "",

      // subjecT_1_CODE: formData.selected_language_one || "",
      // subjecT_2_CODE: formData.selected_language_two || "",
      // subjecT_3_CODE: formData.selected_compulsory_one || "",
      // subjecT_4_CODE: formData.selected_compulsory_two || "",
      // subjecT_5_CODE: formData.selected_compulsory_three || "",
      // subjecT_6_CODE: formData.selected_additional || "",
    };

    let payload = {};
    if (formData.faculty === "SCIENCE" || formData.faculty === "COMMERCE") {
      payload = {
        ...insertPayload,
        subjecT_1_A_TYPE: formData.selected_language_one ? "CL" : "",
        subjecT_1_A_CODE: formData.selected_language_one || "",
        subjecT_1_B_TYPE: formData.selected_language_two ? "MB" : "",
        subjecT_1_B_CODE: formData.selected_language_two || "",
        subjecT_2_TYPE: formData.selected_compulsory_one ? "C1" : "",
        subjecT_2_CODE: formData.selected_compulsory_one || "",
        subjecT_3_TYPE: formData.selected_compulsory_two ? "C2" : "",
        subjecT_3_CODE: formData.selected_compulsory_two || "",
        subjecT_4_TYPE: formData.selected_compulsory_three ? "O1" : "",
        subjecT_4_CODE: formData.selected_compulsory_three || "",
        subjecT_5_TYPE: formData.selected_additional ? "O2" : "",
        subjecT_5_CODE: formData.selected_additional || "",
        subjecT_6_TYPE: formData.selected_elective ? "AL" : "",
        subjecT_6_CODE: formData.selected_elective || "",
      };
    } else if (formData.faculty === "ARTS") {
      payload = {
        ...insertPayload,
        subjecT_1_A_TYPE: formData.selected_language_one ? "CL" : "",
        subjecT_1_A_CODE: formData.selected_language_one || "",
        subjecT_1_B_TYPE: formData.selected_language_two ? "MB" : "",
        subjecT_1_B_CODE: formData.selected_language_two || "",
        subjecT_2_TYPE: formData.selected_compulsory_one ? "EL" : "",
        subjecT_2_CODE: formData.selected_compulsory_one || "",
        subjecT_3_TYPE: formData.selected_compulsory_two ? "O1" : "",
        subjecT_3_CODE: formData.selected_compulsory_two || "",
        subjecT_4_TYPE: formData.selected_compulsory_three ? "O2" : "",
        subjecT_4_CODE: formData.selected_compulsory_three || "",
        subjecT_5_TYPE: formData.selected_additional ? "O3" : "",
        subjecT_5_CODE: formData.selected_additional || "",
        subjecT_6_TYPE: formData.selected_elective ? "AL" : "",
        subjecT_6_CODE: formData.selected_elective || "",
      };
    }
    const apiUrl =
      updatedLateralstatus === "ON"
        ? `InsertDataBettermentStudentRegistration_CL12Lateral`
        : `InsertDataBettermentStudentRegistration_CL12`;
    try {
      const response = await fetch(`${config.API_BASE_URL}/${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setCandidateid12(data.data || "");
        setCastecode12(formData.caste_val || "");
        setDivyangcode12(formData.divyang_val || "");
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data added successfully",
          confirmButtonText: "OK",
        });
        if (finaledit === false) {
          setDocverify12(true);
          Navigate("/class-xii-upload-document");
        } else {
          Navigate("/class-xii-upload-document");
        }

        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "Something went wrong. Please try again later.",
      });
    }
  };
  const handleEditSubmit = async () => {
    const token = sessionStorage.getItem("tokenclassxii");

    // e.preventDefault();
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }

    const insertPayload = {
      candidatE_CODE:
        studentData.candidatE_ID ??
        studentData.editStudent_data.candidatE_ID ??
        "",
      divyang: formData.divyang_val || "",
      religion: formData.religion || "",
      caste: formData.caste_val || "",
      apaaR_ID: formData.apaar_id || "",
      peN_NO: formData.pen_no || "",
    };

    let payload = {};
    if (formData.faculty === "SCIENCE" || formData.faculty === "COMMERCE") {
      payload = {
        ...insertPayload,
        subjecT_1_A_TYPE: formData.selected_language_one ? "CL" : "",
        subjecT_1_A_CODE: formData.selected_language_one || "",
        subjecT_1_B_TYPE: formData.selected_language_two ? "MB" : "",
        subjecT_1_B_CODE: formData.selected_language_two || "",
        subjecT_2_TYPE: formData.selected_compulsory_one ? "C1" : "",
        subjecT_2_CODE: formData.selected_compulsory_one || "",
        subjecT_3_TYPE: formData.selected_compulsory_two ? "C2" : "",
        subjecT_3_CODE: formData.selected_compulsory_two || "",
        subjecT_4_TYPE: formData.selected_compulsory_three ? "O1" : "",
        subjecT_4_CODE: formData.selected_compulsory_three || "",
        subjecT_5_TYPE: formData.selected_additional ? "O2" : "",
        subjecT_5_CODE: formData.selected_additional || "",
        subjecT_6_TYPE: formData.selected_elective ? "AL" : "",
        subjecT_6_CODE: formData.selected_elective || "",
      };
    } else if (formData.faculty === "ARTS") {
      payload = {
        ...insertPayload,
        subjecT_1_A_TYPE: formData.selected_language_one ? "CL" : "",
        subjecT_1_A_CODE: formData.selected_language_one || "",
        subjecT_1_B_TYPE: formData.selected_language_two ? "MB" : "",
        subjecT_1_B_CODE: formData.selected_language_two || "",
        subjecT_2_TYPE: formData.selected_compulsory_one ? "EL" : "",
        subjecT_2_CODE: formData.selected_compulsory_one || "",
        subjecT_3_TYPE: formData.selected_compulsory_two ? "O1" : "",
        subjecT_3_CODE: formData.selected_compulsory_two || "",
        subjecT_4_TYPE: formData.selected_compulsory_three ? "O2" : "",
        subjecT_4_CODE: formData.selected_compulsory_three || "",
        subjecT_5_TYPE: formData.selected_additional ? "O3" : "",
        subjecT_5_CODE: formData.selected_additional || "",
        subjecT_6_TYPE: formData.selected_elective ? "AL" : "",
        subjecT_6_CODE: formData.selected_elective || "",
      };
    }
    const apiUrl =
      updatedLateralstatus === "ON"
        ? `UpdateDataBettermentStudentRegistration_CL12Lateral`
        : `UpdateDataBettermentStudentRegistration_CL12`;
    try {
      const response = await fetch(`${config.API_BASE_URL}/${apiUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setCandidateid12(data.data || "");
        setCastecode12(formData.caste_val || "");
        setDivyangcode12(formData.divyang_val || "");
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Your data edited successfully",
          confirmButtonText: "OK",
        });
        if (finaledit === false) {
          setDocverify12(true);
          Navigate("/class-xii-upload-document");
        } else {
          Navigate("/class-xii-upload-document");
        }

        // window.location.reload();
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "Something went wrong. Please try again later.",
      });
    }
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    setCandidateid12(candidateid12 || "");
    setCastecode12(formData.caste_val || "");
    setDivyangcode12(formData.divyang_val || "");
    if (finaledit === false) {
      setDocverify12(true);
      Navigate("/class-xii-upload-document");
    } else {
      Navigate("/class-xii-upload-document");
    }
  };

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();

    const checkboxes = document.querySelectorAll(
      'input[type="checkbox"][name^="subject_"], .input-group-text input[type="checkbox"]'
    );

    const isAnyChecked = Array.from(checkboxes).some((cb) => cb.checked);

    if (!isAnyChecked) {
      Swal.fire({
        icon: "warning",
        title: "Please select at least one subject checkbox.",
      });
      setLoading(false);
      return;
    }

    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");
      if (penno && penno.length >= 11 && penno.length <= 14) {
        const token = sessionStorage.getItem("tokenclassxii");
        try {
          const response = await fetch(
            `${config.API_BASE_URL}/PENNoCheckingStudentData_CL12`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                candidatE_ID: candidateid12 || "",
                peN_NO: penno,
              }),
            }
          );
          const result = await response.json();

          if (result.status === 404) {
            Swal.fire({
              icon: "warning",
              title: "PEN No. Already Exists.",
            });
            setFormData((prev) => ({
              ...prev,
              pen_no: "",
            }));
            setLoading(false);
            return;
          }
        } catch (error) {
          console.error("Error verifying PEN No.", error);
          setLoading(false);
          return;
        }
      }
    }

    const newErrors = {};

    if (!formData.divyang_val) {
      newErrors.divyang_val = "Divyang selection is required.";
    }
    if (fieldsMissing.caste && !formData.caste_val) {
      newErrors.caste_val = "Caste is required.";
    }
    if (fieldsMissing.religion && !formData.religion) {
      newErrors.religion = "Religion is required.";
    }
    if (!trimmed(formData.pen_no)) {
      newErrors.pen_no = "PEN No. is required.";
    } else if (!/^\d{11,14}$/.test(formData.pen_no)) {
      newErrors.pen_no = "PEN No. must be between 11 to 14 digits.";
    }
    if (!/^\d{12}$/.test(formData.apaar_id) && formData.apaar_id) {
      newErrors.apaar_id = "Apaar ID must be exactly 12 digits.";
    }
    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  return (
    <>
      <div class="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        <Navbar12 />
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header ">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Add Improvement
                      Student (Student Registration Page for Board Examination)
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            Navigate("/class-xii-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active"> Add Student (JAC)</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Class XII Passing Details</h4>
                    </div>
                    <div class="card-body">
                      <div
                        class="row d-flex"
                        style={{ justifyContent: "center" }}
                      >
                        <div class="col-md-10 py-3">
                          <div class="row">
                            <label class="col-md-3">Year of Passing:</label>
                            <div class="col-md-2">
                              <input
                                type="text"
                                class="form-control form-control-xs"
                                value={formData.passingyear || ""}
                                disabled
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">Roll Code:</label>
                            <div class="col-md-3">
                              <input
                                class="form-control form-control-xs number"
                                id="roll_code"
                                required=""
                                value={formData.roll_code || ""}
                                disabled
                              />
                            </div>
                          </div>
                          <div class="row mt-3">
                            <label class="col-md-3">Roll Number:</label>
                            <div class="col-md-3">
                              <input
                                class="form-control form-control-xs number"
                                id="roll_number"
                                required=""
                                value={formData.roll_number || ""}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-6 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Name of Student</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    disabled
                                    class="form-control form-control-sm disable count"
                                    name="candidate_name"
                                    value={formData.candidate_name || ""}
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Gender</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.gender || ""}
                                />
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Date of Birth</label>
                                <DatePicker
                                  id="birth_date"
                                  name="birth_date"
                                  selected={
                                    formData.date_of_birth
                                      ? (() => {
                                          const [dd, mm, yyyy] =
                                            formData.date_of_birth.split("-");
                                          return new Date(
                                            Number(yyyy),
                                            Number(mm) - 1,
                                            Number(dd)
                                          );
                                        })()
                                      : null
                                  }
                                  onChange={(date) => {
                                    if (date) {
                                      const dd = String(
                                        date.getDate()
                                      ).padStart(2, "0");
                                      const mm = String(
                                        date.getMonth() + 1
                                      ).padStart(2, "0");
                                      const yyyy = date.getFullYear();

                                      setFormData({
                                        ...formData,
                                        date_of_birth: `${dd}-${mm}-${yyyy}`, // store dd-mm-yyyy
                                      });
                                    } else {
                                      setFormData({
                                        ...formData,
                                        date_of_birth: "",
                                      });
                                    }
                                  }}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control form-control-sm disable"
                                  placeholderText="dd-mm-yyyy"
                                  disabled
                                  onKeyDown={(e) => e.preventDefault()}
                                  // maxDate={new Date("2013-03-01")}
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={60}
                                />
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Father’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="father_name"
                                    disabled
                                    class="form-control form-control-sm disable count1"
                                    value={formData.fathers_name || ""}
                                    placeholder="Father’s Name"
                                  />
                                </div>
                              </div>
                            </div>

                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>
                                  Religion{" "}
                                  {fieldsMissing.religion && (
                                    <span class="text-danger">&nbsp;*</span>
                                  )}
                                </label>
                                <select
                                  className={`form-select form-select-sm ${
                                    errors.religion ? "is-invalid" : ""
                                  }`}
                                  name="religion"
                                  // disabled
                                  id="religion"
                                  onChange={handleChange}
                                  value={formData.religion || ""}
                                  disabled={
                                    !(fieldsMissing.religion && !isPreviewed)
                                  }
                                >
                                  <option value="">Select</option>
                                  {religionList.map((religion) => (
                                    <option
                                      key={religion.religioN_ID}
                                      value={religion.religioN_ID}
                                    >
                                      {religion.religioN_NAME}
                                    </option>
                                  ))}
                                </select>
                                {errors.religion && (
                                  <div className="text-danger mt-1 small">
                                    {errors.religion}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div class="col-lg-3 col-m-6">
                              <div class="form-group  mb-3">
                                <label>Nationality</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.nationality}
                                />
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Mother’s Name</label>
                                <div class="input-group">
                                  <input
                                    type="text"
                                    name="mother_name"
                                    disabled
                                    class="form-control form-control-sm disable count2"
                                    value={formData.mothers_name || ""}
                                    placeholder="Mother’s Name"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6">
                              <div class="form-group  mb-3">
                                <label>Student Aadhaar Number</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={formData.aadhaar_no}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-12">
                          <div class="form-group mb-3">
                            <label>
                              Divyang <span class="text-danger">*</span>
                            </label>
                            <select
                              className={`form-select form-select-sm ${
                                errors.divyang_val ? "is-invalid" : ""
                              }`}
                              // className="form-select form-select-sm"
                              id="divyang_val"
                              name="divyang_val"
                              value={formData.divyang_val}
                              onChange={handleChange}
                              disabled={isPreviewed}
                            >
                              <option value="">Select</option>
                              {divyangList.map((divyang) => (
                                <option
                                  key={divyang.divyanG_ID}
                                  value={divyang.divyanG_ID}
                                >
                                  {divyang.divyanG_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.divyang_val && (
                              <div className="text-danger mt-1 small">
                                {errors.divyang_val}
                              </div>
                            )}
                          </div>
                          <div class="form-group mb-3">
                            <label>
                              Caste{" "}
                              {fieldsMissing.caste && (
                                <span class="text-danger">&nbsp;*</span>
                              )}
                            </label>
                            <select
                              className={`form-select form-select-sm ${
                                errors.caste_val ? "is-invalid" : ""
                              }`}
                              // className="form-select form-select-sm"
                              name="caste_val"
                              id="caste_val"
                              value={formData.caste_val}
                              onChange={handleChange}
                              // disabled
                              disabled={!(fieldsMissing.caste && !isPreviewed)}
                            >
                              <option value="">Choose Caste</option>
                              {casteListnew.map((caste) => (
                                <option
                                  key={caste.castE_ID}
                                  value={caste.castE_ID}
                                >
                                  {caste.castE_NAME}
                                </option>
                              ))}
                            </select>
                            {errors.caste_val && (
                              <div className="text-danger mt-1 small">
                                {errors.caste_val}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-9 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Educational Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Category Choice</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  value={
                                    formData.category_choice === "BETTERMENT"
                                      ? "IMPROVEMENT"
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-4">
                              <div class="form-group mb-3">
                                <label>Board Name</label>
                                <input
                                  type="text"
                                  disabled
                                  class="form-control form-control-sm"
                                  name="board_name"
                                  id="board_name"
                                  value={formData.board_name || ""}
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-group mb-3">
                                <label>Stream</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm"
                                  value={formData.faculty}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12 mb-3" id="paper1">
                              <h4>Core Subjects</h4>
                              <hr />
                              <div class="row">
                                {/* {formData.language_one_code && ( */}
                                <>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>Core Language</label>
                                      <div class="input-group">
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          value={formData.language_one}
                                          disabled
                                        />
                                        <span
                                          class="input-group-text padding-13"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          data-bs-original-title="Please Check"
                                        >
                                          <input
                                            disabled={
                                              !formData.language_one_code ||
                                              isPreviewed
                                            }
                                            type="checkbox"
                                            className="check_subject"
                                            checked={
                                              formData.selected_language_one ===
                                                formData.language_one_code &&
                                              formData.selected_language_one !==
                                                ""
                                            }
                                            onChange={(e) =>
                                              setFormData((prev) => ({
                                                ...prev,
                                                selected_language_one: e.target
                                                  .checked
                                                  ? formData.language_one_code
                                                  : "",
                                              }))
                                            }
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                                {/* )} */}
                                {/* {formData.language_two_code && ( */}
                                <>
                                  <div class="col-md-4">
                                    <div class="form-group mb-3">
                                      <label>Matri Bhasa</label>
                                      <div class="input-group">
                                        <input
                                          type="text"
                                          class="form-control form-control-sm"
                                          value={formData.language_two}
                                          disabled
                                        />
                                        <span
                                          class="input-group-text padding-13"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          data-bs-original-title="Please Check"
                                        >
                                          <input
                                            disabled={
                                              !formData.language_two_code ||
                                              isPreviewed
                                            }
                                            type="checkbox"
                                            className="check_subject"
                                            checked={
                                              formData.selected_language_two ===
                                                formData.language_two_code &&
                                              formData.selected_language_two !==
                                                ""
                                            }
                                            onChange={(e) =>
                                              setFormData((prev) => ({
                                                ...prev,
                                                selected_language_two: e.target
                                                  .checked
                                                  ? formData.language_two_code
                                                  : "",
                                              }))
                                            }
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                                {/* )} */}
                              </div>
                            </div>
                            {formData.faculty === "SCIENCE" && (
                              <>
                                <div class="col-md-12 mb-3" id="science_paper2">
                                  <h4>Compulsory Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    {/* {formData.compulsory_one_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Compulsory 1</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_one}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_one_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_one ===
                                                    formData.compulsory_one_code &&
                                                  formData.selected_compulsory_one !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_one: e
                                                      .target.checked
                                                      ? formData.compulsory_one_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                    {/* {formData.compulsory_two_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Compulsory 2</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_two}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_two_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_two ===
                                                    formData.compulsory_two_code &&
                                                  formData.selected_compulsory_two !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_two: e
                                                      .target.checked
                                                      ? formData.compulsory_two_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                  </div>
                                </div>

                                <div class="col-md-12 mb-3" id="science_paper3">
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    {/* {formData.compulsory_three_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 1</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_three}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_three_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_three ===
                                                    formData.compulsory_three_code &&
                                                  formData.selected_compulsory_three !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_three: e
                                                      .target.checked
                                                      ? formData.compulsory_three_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                    {/* {formData.additional_subject_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 2</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={
                                                formData.additional_subject
                                              }
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.additional_subject_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_additional ===
                                                    formData.additional_subject_code &&
                                                  formData.selected_additional !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_additional: e
                                                      .target.checked
                                                      ? formData.additional_subject_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                  </div>
                                </div>
                                {/* {formData.elective_subject_code && ( */}
                                <div class="col-md-12" id="science_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <>
                                      <div class="col-md-4 mb-2">
                                        <div class="form-group mb-3">
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.elective_subject}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.elective_subject_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_elective ===
                                                    formData.elective_subject_code &&
                                                  formData.selected_elective !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_elective: e.target
                                                      .checked
                                                      ? formData.elective_subject_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                                {/* )} */}
                              </>
                            )}
                            {formData.faculty === "COMMERCE" && (
                              <>
                                <div
                                  class="col-md-12 mb-3"
                                  id="commerce_paper2"
                                >
                                  <h4>Compulsory Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    {/* {formData.compulsory_one_code && ( */}
                                    <>
                                      {" "}
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Compulsory 1</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_one}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_one_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_one ===
                                                    formData.compulsory_one_code &&
                                                  formData.selected_compulsory_one !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_one: e
                                                      .target.checked
                                                      ? formData.compulsory_one_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                    {/* {formData.compulsory_two_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Compulsory 2</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_two}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_two_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_two ===
                                                    formData.compulsory_two_code &&
                                                  formData.selected_compulsory_two !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_two: e
                                                      .target.checked
                                                      ? formData.compulsory_two_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                  </div>
                                </div>

                                <div
                                  class="col-md-12 mb-3"
                                  id="commerce_paper3"
                                >
                                  <h4>Optional Subjects</h4>
                                  <hr />
                                  <div class="row">
                                    {/* {formData.compulsory_three_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 1</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_three}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_three_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_three ===
                                                    formData.compulsory_three_code &&
                                                  formData.selected_compulsory_three !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_three: e
                                                      .target.checked
                                                      ? formData.compulsory_three_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                    {/* {formData.additional_subject_code && ( */}
                                    <>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 2</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={
                                                formData.additional_subject
                                              }
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.additional_subject_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_additional ===
                                                    formData.additional_subject_code &&
                                                  formData.selected_additional !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_additional: e
                                                      .target.checked
                                                      ? formData.additional_subject_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    {/* )} */}
                                  </div>
                                </div>
                                {/* {formData.elective_subject_code && ( */}
                                <div class="col-md-12" id="commerce_additional">
                                  <h4>Additional Subject </h4>
                                  <hr />
                                  <div class="row">
                                    <>
                                      <div class="col-md-4 mb-2">
                                        <div class="form-group mb-3">
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.elective_subject}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.elective_subject_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_elective ===
                                                    formData.elective_subject_code &&
                                                  formData.selected_elective !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_elective: e.target
                                                      .checked
                                                      ? formData.elective_subject_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                                {/* )} */}
                              </>
                            )}
                            {formData.faculty === "ARTS" && (
                              <>
                                <div class="col-md-12 mb-3" id="arts_paper2">
                                  <h4>Elective Subject</h4>
                                  <hr />
                                  <div class="row">
                                    {/* {formData.compulsory_one_code && ( */}

                                    <div class="col-md-4">
                                      <div class="form-group mb-3">
                                        <label>Elective Language</label>
                                        <div class="input-group">
                                          <input
                                            disabled
                                            type="text"
                                            class="form-control form-control-sm select-disable"
                                            value={formData.compulsory_one}
                                          />
                                          <span
                                            class="input-group-text padding-13"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            data-bs-original-title="Please Check"
                                          >
                                            <input
                                              disabled={
                                                !formData.compulsory_one_code ||
                                                isPreviewed
                                              }
                                              type="checkbox"
                                              className="check_subject"
                                              checked={
                                                formData.selected_compulsory_one ===
                                                  formData.compulsory_one_code &&
                                                formData.selected_compulsory_one !==
                                                  ""
                                              }
                                              onChange={(e) =>
                                                setFormData((prev) => ({
                                                  ...prev,
                                                  selected_compulsory_one: e
                                                    .target.checked
                                                    ? formData.compulsory_one_code
                                                    : "",
                                                }))
                                              }
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    {/* )} */}
                                    {/* {formData.compulsory_two_code && ( */}

                                    {/* )} */}
                                  </div>
                                </div>
                                {/* {formData.additional_subject_code && ( */}
                                <>
                                  <div class="col-md-12 mb-3" id="arts_paper3">
                                    <h4>Optional Subjects</h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 1</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_two}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_two_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_two ===
                                                    formData.compulsory_two_code &&
                                                  formData.selected_compulsory_two !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_two: e
                                                      .target.checked
                                                      ? formData.compulsory_two_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 2</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.compulsory_three}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.compulsory_three_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_compulsory_three ===
                                                    formData.compulsory_three_code &&
                                                  formData.selected_compulsory_three !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_compulsory_three: e
                                                      .target.checked
                                                      ? formData.compulsory_three_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-3">
                                          <label>Optional 3</label>
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={
                                                formData.additional_subject
                                              }
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.additional_subject_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_additional ===
                                                    formData.additional_subject_code &&
                                                  formData.selected_additional !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_additional: e
                                                      .target.checked
                                                      ? formData.additional_subject_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                                {/* )} */}
                                {/* {formData.elective_subject_code && ( */}
                                <>
                                  <div class="col-md-12" id="arts_additional">
                                    <h4>Additional Subject </h4>
                                    <hr />
                                    <div class="row">
                                      <div class="col-md-4 mb-2">
                                        <div class="form-group mb-3">
                                          <div class="input-group">
                                            <input
                                              disabled
                                              type="text"
                                              class="form-control form-control-sm select-disable"
                                              value={formData.elective_subject}
                                            />
                                            <span
                                              class="input-group-text padding-13"
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              data-bs-original-title="Please Check"
                                            >
                                              <input
                                                disabled={
                                                  !formData.elective_subject_code ||
                                                  isPreviewed
                                                }
                                                type="checkbox"
                                                className="check_subject"
                                                checked={
                                                  formData.selected_elective ===
                                                    formData.elective_subject_code &&
                                                  formData.selected_elective !==
                                                    ""
                                                }
                                                onChange={(e) =>
                                                  setFormData((prev) => ({
                                                    ...prev,
                                                    selected_elective: e.target
                                                      .checked
                                                      ? formData.elective_subject_code
                                                      : "",
                                                  }))
                                                }
                                              />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                                {/* )} */}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-m-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header card-green">
                      <h4 class="mb-0 p-2">Other Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="form-group mb-3">
                        <label>
                          Permanent Education Number (PEN){" "}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="pen_no"
                          name="pen_no"
                          className={`form-control form-control-sm ${
                            errors.pen_no ? "is-invalid" : ""
                          }`}
                          placeholder="Enter PEN NO"
                          value={formData.pen_no}
                          maxlength="14"
                          onBlur={handlePenBlur}
                          onChange={(e) => {
                            const onlyNums2 = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "pen_no", value: onlyNums2 },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.pen_no && (
                          <div className="text-danger mt-1 small">
                            {errors.pen_no}
                          </div>
                        )}
                      </div>
                      <div class="form-group mb-3">
                        <label>APAAR ID</label>
                        <input
                          maxlength="12"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          id="apaar_id"
                          name="apaar_id"
                          className={`form-control form-control-sm ${
                            errors.apaar_id ? "is-invalid" : ""
                          }`}
                          placeholder="Enter APAAR ID"
                          value={formData.apaar_id}
                          onChange={(e) => {
                            const onlyNums = e.target.value.replace(/\D/g, "");
                            handleChange({
                              target: { name: "apaar_id", value: onlyNums },
                            });
                          }}
                          disabled={isPreviewed}
                        />
                        {errors.apaar_id && (
                          <div className="text-danger mt-1 small">
                            {errors.apaar_id}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
      </div>
    </>
  );
}

export default Addimprovementsecond12;
